import { render, staticRenderFns } from "./ContractPage.vue?vue&type=template&id=a9156f80"
import script from "./ContractPage.vue?vue&type=script&lang=js"
export * from "./ContractPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports